import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';

import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
import DialogService from 'primevue/dialogservice';
import Tooltip from 'primevue/tooltip';
import 'primeicons/primeicons.css';
import { vFinancialTooltip } from './directives/financial/vFinancialTooltip';

const app = createApp(App);

app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: { darkModeSelector: '.dark-mode' },
  },
});

app.directive('tooltip', Tooltip);
app.directive('financial-tooltip', vFinancialTooltip);

app.use(ToastService);
app.use(ConfirmationService);
app.use(DialogService);

app.use(createPinia());
app.use(router);

app.mount('#app');
